import React, { useState, useEffect, useRef } from 'react';

export const VideoThumbnail = ({ videoSrc, thumbnailUrl, alt, className }) => {
  const [thumbnail, setThumbnail] = useState(thumbnailUrl);
  const [error, setError] = useState(false);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  useEffect(() => {
    // If thumbnail URL exists, use it
    if (thumbnailUrl) {
      setThumbnail(thumbnailUrl);
      return;
    }

    // Otherwise, try to generate thumbnail from video
    if (videoSrc && !error) {
      generateThumbnail();
    }
  }, [videoSrc, thumbnailUrl, error]);

  const generateThumbnail = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;

    if (!video || !canvas) return;

    video.currentTime = 1; // Capture frame at 1 second
  };

  const handleVideoLoaded = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;

    if (!video || !canvas) return;

    // Set canvas dimensions to match video
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    // Draw the video frame to canvas
    const ctx = canvas.getContext('2d');
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    // Convert canvas to data URL
    const dataUrl = canvas.toDataURL('image/jpeg', 0.8);
    setThumbnail(dataUrl);
  };

  const handleVideoError = () => {
    setError(true);
    setThumbnail(null);
  };

  const handleImageError = () => {
    setThumbnail(null);
  };

  return (
    <>
      {/* Display thumbnail */}
      {thumbnail ? (
        <img
          src={thumbnail}
          alt={alt || 'Video thumbnail'}
          className={className}
          onError={handleImageError}
        />
      ) : (
        // Fallback placeholder
        <div className={`${className} bg-gradient-to-br from-slate-700 to-slate-800 flex items-center justify-center`}>
          <svg className="w-12 h-12 text-slate-500" fill="currentColor" viewBox="0 0 20 20">
            <path d="M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z" />
          </svg>
        </div>
      )}

      {/* Hidden video element for thumbnail generation */}
      {videoSrc && !thumbnailUrl && !error && (
        <>
          <video
            ref={videoRef}
            src={videoSrc}
            crossOrigin="anonymous"
            onLoadedData={handleVideoLoaded}
            onError={handleVideoError}
            className="hidden"
            muted
            playsInline
          />
          <canvas ref={canvasRef} className="hidden" />
        </>
      )}
    </>
  );
};

export default VideoThumbnail;
